module.exports = new __parcel__URL__("battlepass_success_info_text.4bedac92.png").toString();